import { handleApiErrorResponse } from "../lib/helpers";

/**
 * PUT full survey question list for a test (unified create/update/delete in one call).
 * Body: JSON array of question objects (sort_order, options, jumpTo, optionImages, etc.)
 *
 * @param {string|number} testId - Test id from route
 * @param {Array<object>} questionsPayload - Survey questions array (same shape as API body)
 * @param {string} token - Auth token (without "Bearer " prefix)
 * @param {AbortSignal} [signal] - Optional abort signal
 * @returns {Promise<object>}
 */
export function putTestSurveyQuestions(testId, questionsPayload, token, signal) {
	const base = process.env.REACT_APP_BACKEND_URL || "";
	const url = `${base}api/v2/researcher/workspaces/projects/tests/${testId}/survey`;

	return fetch(url, {
		method: "PUT",
		body: JSON.stringify(questionsPayload),
		headers: {
			Accept: "application/json",
			"Content-Type": "application/json",
			Authorization: "Bearer " + token,
		},
		signal,
	})
		.then((res) => {
			const isJson = res.headers.get("content-type")?.includes("application/json");
			const data = isJson ? res.json() : null;

			if (!res.ok) {
				const error = (data && data.message) || res.status;
				return Promise.reject(error);
			}

			return data;
		})
		.catch((res) => {
			handleApiErrorResponse(res);
			return { success: false };
		});
}
